import Header from '@/components/header/Header.vue';

export default {
  name: 'InfoView',
  components: {
    Header
  },
  data() {
    return {
      activeModal: null, // 'terms' | 'privacy' | 'about' | 'help' | null
    };
  },
  methods: {
    openModal(type) {
      this.activeModal = type;
    },
    closeModal() {
      this.activeModal = null;
    },
    checkDeviceWidth() {
      if (typeof window !== 'undefined' && window.innerWidth >= 992) {
        this.$router.replace('/');
      }
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.checkDeviceWidth();
    window.addEventListener('resize', this.checkDeviceWidth);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkDeviceWidth);
  }
};

